import { Button, InputAdornment, Modal, TextField } from '@mui/material';
import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import request from '../../../Helpers/API';
import { LoaderScreen } from '../../components/LoaderScreen';
import { FormatMoney } from '../../../Helpers/FormatNumber';

export const ModalUtilidadMargen = ({ open, handleClose, datos, ObtenerListado }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const [formData, setFormData] = useState({
        utilidad: '',
        margen: '',
        costo: '',
        precio_lista: ''
    });

    useEffect(() => {
        if (datos) {
            setFormData({
                utilidad: datos.utilidad || '',
                margen: datos.margen || '',
                costo: datos.costo || '',
                precio_lista: datos.precio_lista || ''
            });
        }
    }, [datos]);

    const calcularDesdeMargen = (margenDecimal) => {
        if (formData.costo) {
            const costo = parseFloat(formData.costo);
            const precio_lista = costo / (1 - margenDecimal);
            const utilidad = precio_lista - costo;

            setFormData((prev) => ({
                ...prev,
                utilidad: utilidad.toFixed(2),
                precio_lista: precio_lista.toFixed(2),
            }));
        }
    };

    const calcularDesdeUtilidad = (utilidad) => {
        if (formData.costo) {
            const costo = parseFloat(formData.costo);
            const precio_lista = costo + utilidad;
            const margen = (utilidad / precio_lista) * 100; // Convertir a porcentaje

            setFormData((prev) => ({
                ...prev,
                margen: margen.toFixed(2), // Mostrar en porcentaje (ej. 15 en vez de 0.15)
                precio_lista: precio_lista.toFixed(2),
            }));
        }
    };

    const formatWithCommas = (value) => {
        if (!value) return '';
        return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    const removeCommas = (value) => {
        return value.replace(/,/g, '');
    };

    const handleChange = (e) => {
        const { id, value } = e.target;

        // Permitir solo números y un punto decimal
        let numericValue = value.replace(/[^0-9.]/g, '');

        // Evitar múltiples puntos decimales
        if ((numericValue.match(/\./g) || []).length > 1) {
            return;
        }

        // Si es "margen", restringir máximo 99
        if (id === "margen") {
            let num = parseFloat(numericValue);

            // Permitir que el usuario escriba el punto al final (ej. "99.")
            if (numericValue === "" || numericValue === ".") {
                numericValue = "";
            } else if (!isNaN(num) && num > 99) {
                numericValue = "99"; // Ajustar a 99 si se excede
            }
        }

        setFormData((prev) => ({ ...prev, [id]: numericValue }));

        if (id === "margen" && numericValue !== "" && numericValue !== ".") {
            calcularDesdeMargen(parseFloat(numericValue) / 100);
        } else if (id === "utilidad" && numericValue !== "" && numericValue !== ".") {
            calcularDesdeUtilidad(parseFloat(numericValue));
        }
    };




    const onGuardar = () => {
        // console.log(formData)
        const post = {
            idinventario: datos.idinventario,
            utilidad: formData.utilidad,
            margen: formData.margen,
            precio_lista: formData.precio_lista
        }

        request
            .post("ListadoPreciosProductoAliado/ActualizarPrecio", post)
            .then(async () => {
                setLoader({ ...loader, mostrar: false });
                handleClose();
                ObtenerListado()
                await Swal.fire({
                    title: "LISTADO DE PRECIOS",
                    text: "Precio de lista actualizado",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CARGA DE EVIDENCIA", JSON.stringify(error), "error");
            });
    };
    return (
        <Modal open={open}>
            <div className="otros-modal">
                <LoaderScreen loader={loader} />
                <div className="otros-modal-title">
                    <div className="filtro-soy-el-titulo-header">
                        <h3>CAMBIAR UTILIDAD/MARGEN</h3>
                    </div>
                </div>
                <div className="imagen-modal-soy-el-titulo-line">
                    <div className="imagen-modal-soy-el-titulo-line-bl"></div>
                    <div className="imagen-modal-soy-el-titulo-line-circle"></div>
                    <div className="imagen-modal-soy-el-titulo-line-br"></div>
                </div>

                <div>
                    <div className="">
                        <TextField
                            id="utilidad"
                            label="Utilidad"
                            type="text"
                            value={formatWithCommas(formData.utilidad)} // Mostrar comas mientras escribe
                            onChange={handleChange}
                            onKeyUp={(e) => e.target.value = formatWithCommas(e.target.value)} // Mostrar comas mientras el usuario escribe
                            sx={{ mb: 2, width: 540 }}
                        />
                        <TextField
                            id="margen"
                            label="Margen"
                            type="text"
                            value={formData.margen}
                            onChange={handleChange}
                            sx={{ mb: 2, width: 540 }}
                        />

                        <TextField
                            id="costo"
                            label="Costo"
                            type="text"
                            value={FormatMoney(formData.costo)}
                            disabled
                            sx={{ mb: 2, width: 540 }}
                        />
                        <TextField
                            id="precio_lista"
                            label="Precio de Lista"
                            type="text"
                            value={FormatMoney(formData.precio_lista)}
                            disabled
                            sx={{ mb: 2, width: 540 }}
                        />
                    </div>
                </div>
                <div className="imagen-modal-button-container ">
                    <div className="cerrar-button" onClick={handleClose} style={{ cursor: "pointer" }}>
                        Cerrar
                    </div>
                    <div className="right-buttons">
                        <div className="agregar-button"
                            onClick={
                                () => onGuardar()
                            }
                            style={{ cursor: "pointer" }}>
                            Agregar
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
};